import { render, staticRenderFns } from "./TrivyAnalyzer.vue?vue&type=template&id=40b82dbb&"
import script from "./TrivyAnalyzer.vue?vue&type=script&lang=js&"
export * from "./TrivyAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b82dbb')) {
      api.createRecord('40b82dbb', component.options)
    } else {
      api.reload('40b82dbb', component.options)
    }
    module.hot.accept("./TrivyAnalyzer.vue?vue&type=template&id=40b82dbb&", function () {
      api.rerender('40b82dbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/analyzers/TrivyAnalyzer.vue"
export default component.exports